export default __webpack_public_path__ + "static/media/LametHabayebGroupImage.2e3be6a1.png";